import { Outlet, NavLink, useNavigate } from 'react-router'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlay, faTag, faBook, faArrowRight, faRightToBracket, faRocket, faBars, faXmark } from '@fortawesome/free-solid-svg-icons'
import { useAuth } from '../contexts/AuthContext'
import { useIsMobile } from '../hooks/useMediaQuery'
import { colors, spacing, fontSize, radius, shadow, fontFamily } from '../styles/theme'
import { useState } from 'react'

const NAV_LINKS = [
  { to: '/demo',            label: 'Demo',    icon: faPlay },
  { to: '/pricing',         label: 'Pricing', icon: faTag },
  { to: '/docs/templates',  label: 'Docs',    icon: faBook },
]

export default function PublicLayout() {
  const { user } = useAuth()
  const navigate = useNavigate()
  const isMobile = useIsMobile()
  const [menuOpen, setMenuOpen] = useState(false)

  return (
    <div style={{ minHeight: '100vh', background: colors.background, fontFamily: fontFamily.sans }}>
      <header style={{
        position: 'sticky', top: 0, zIndex: 100,
        background: 'rgba(255,255,255,0.95)', backdropFilter: 'blur(8px)',
        borderBottom: `1px solid ${colors.border}`, boxShadow: shadow.sm,
      }}>
        <div style={{ maxWidth: 1200, margin: '0 auto', padding: `0 ${spacing.lg}`, height: 60, display: 'flex', alignItems: 'center', gap: spacing.lg }}>
          {isMobile && (
            <button
              onClick={() => setMenuOpen(o => !o)}
              style={{ background: 'transparent', border: 'none', fontSize: '18px', cursor: 'pointer', color: colors.text, padding: '4px', lineHeight: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}
              aria-label="Menu"
            >
              <FontAwesomeIcon icon={menuOpen ? faXmark : faBars} />
            </button>
          )}
          <a href="/" style={{ textDecoration: 'none', display: 'flex', alignItems: 'center', gap: spacing.sm, flexShrink: 0 }}>
            <span style={{ fontWeight: 600, fontSize: fontSize.lg, color: colors.text, letterSpacing: '-0.02em', fontFamily: fontFamily.sans }}>
              Doc<span style={{ color: colors.primary }}>morph</span>ia
            </span>
          </a>

          {!isMobile && (
            <nav style={{ display: 'flex', alignItems: 'center', gap: spacing.xs }}>
              {NAV_LINKS.map(({ to, label, icon }) => (
                <NavLink
                  key={to}
                  to={to}
                  style={({ isActive }) => ({
                    display: 'flex', alignItems: 'center', gap: 6,
                    padding: `6px ${spacing.md}`,
                    borderRadius: radius.full,
                    fontSize: fontSize.base,
                    fontWeight: isActive ? 600 : 400,
                    color: isActive ? colors.primary : colors.textSecondary,
                    textDecoration: 'none',
                    background: isActive ? colors.primaryLight : 'transparent',
                    transition: 'all 0.15s',
                  })}
                >
                  <FontAwesomeIcon icon={icon} style={{ width: 13 }} />
                  {label}
                </NavLink>
              ))}
            </nav>
          )}

          <div style={{ flex: 1 }} />

          {user ? (
            <button
              onClick={() => navigate('/app/dashboard')}
              style={{ display: 'flex', alignItems: 'center', gap: 8, padding: `8px ${spacing.lg}`, background: colors.primary, color: '#fff', border: 'none', borderRadius: radius.full, fontSize: fontSize.base, fontWeight: 600, cursor: 'pointer', whiteSpace: 'nowrap' }}
            >
              Go to App
              <FontAwesomeIcon icon={faArrowRight} />
            </button>
          ) : (
            <div style={{ display: 'flex', alignItems: 'center', gap: spacing.sm }}>
              {!isMobile && (
                <button
                  onClick={() => navigate('/login')}
                  style={{ display: 'flex', alignItems: 'center', gap: 8, padding: `8px ${spacing.md}`, background: 'transparent', color: colors.text, border: `1px solid ${colors.border}`, borderRadius: radius.full, fontSize: fontSize.base, fontWeight: 500, cursor: 'pointer' }}
                >
                  <FontAwesomeIcon icon={faRightToBracket} style={{ width: 13 }} />
                  Sign in
                </button>
              )}
              <button
                onClick={() => navigate('/register')}
                style={{ display: 'flex', alignItems: 'center', gap: 8, padding: `8px ${spacing.lg}`, background: colors.primary, color: '#fff', border: 'none', borderRadius: radius.full, fontSize: fontSize.base, fontWeight: 600, cursor: 'pointer', whiteSpace: 'nowrap' }}
              >
                <FontAwesomeIcon icon={faRocket} style={{ width: 13 }} />
                Start free trial
              </button>
            </div>
          )}

        </div>

        {isMobile && menuOpen && (
          <div style={{ background: colors.surface, borderTop: `1px solid ${colors.border}`, padding: `${spacing.sm} ${spacing.lg} ${spacing.md}` }}>
            {NAV_LINKS.map(({ to, label, icon }) => (
              <a
                key={to}
                href={to}
                onClick={() => setMenuOpen(false)}
                style={{ display: 'flex', alignItems: 'center', gap: 10, padding: `${spacing.sm} 0`, fontSize: fontSize.md, fontWeight: 500, color: colors.text, textDecoration: 'none', borderBottom: `1px solid ${colors.border}` }}
              >
                <FontAwesomeIcon icon={icon} style={{ width: 14, color: colors.textSecondary }} />
                {label}
              </a>
            ))}
            {!user && (
              <a
                href="/login"
                onClick={() => setMenuOpen(false)}
                style={{ display: 'flex', alignItems: 'center', gap: 10, padding: `${spacing.sm} 0`, fontSize: fontSize.md, fontWeight: 500, color: colors.text, textDecoration: 'none' }}
              >
                <FontAwesomeIcon icon={faRightToBracket} style={{ width: 14, color: colors.textSecondary }} />
                Sign in
              </a>
            )}
          </div>
        )}
      </header>

      <Outlet />

      <footer style={{ borderTop: `1px solid ${colors.border}`, background: colors.surface, marginTop: spacing.xxl }}>
        <div style={{ maxWidth: 1200, margin: '0 auto', padding: `${spacing.xl} ${spacing.lg}`, display: 'flex', flexWrap: 'wrap', gap: spacing.xl, justifyContent: 'space-between', alignItems: 'flex-start' }}>
          <div>
            <div style={{ fontWeight: 600, fontSize: fontSize.lg, color: colors.text, marginBottom: spacing.sm, letterSpacing: '-0.02em' }}>
              Doc<span style={{ color: colors.primary }}>morph</span>ia
            </div>
            <div style={{ fontSize: fontSize.sm, color: colors.textSecondary, maxWidth: 260 }}>
              Word templates populated with your data, delivered as PDFs — in one API call.
            </div>
          </div>
          <div style={{ display: 'flex', gap: spacing.xxl, flexWrap: 'wrap' }}>
            <div>
              <div style={{ fontSize: fontSize.xs, fontWeight: 700, color: colors.textMuted, textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: spacing.sm }}>Product</div>
              {[['/', 'Home'], ['/demo', 'Live Demo'], ['/pricing', 'Pricing'], ['/security', 'Security']].map(([href, label]) => (
                <a key={href} href={href} style={{ display: 'block', fontSize: fontSize.sm, color: colors.textSecondary, textDecoration: 'none', marginBottom: 6 }}>{label}</a>
              ))}
            </div>
            <div>
              <div style={{ fontSize: fontSize.xs, fontWeight: 700, color: colors.textMuted, textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: spacing.sm }}>Docs</div>
              {[['/docs/templates', 'Template Guide'], ['/docs/api', 'API Reference']].map(([href, label]) => (
                <a key={href} href={href} style={{ display: 'block', fontSize: fontSize.sm, color: colors.textSecondary, textDecoration: 'none', marginBottom: 6 }}>{label}</a>
              ))}
            </div>
            <div>
              <div style={{ fontSize: fontSize.xs, fontWeight: 700, color: colors.textMuted, textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: spacing.sm }}>Account</div>
              {[['/login', 'Sign in'], ['/register', 'Start free trial']].map(([href, label]) => (
                <a key={href} href={href} style={{ display: 'block', fontSize: fontSize.sm, color: colors.textSecondary, textDecoration: 'none', marginBottom: 6 }}>{label}</a>
              ))}
            </div>
          </div>
        </div>
        <div style={{ borderTop: `1px solid ${colors.border}`, padding: `${spacing.md} ${spacing.lg}`, maxWidth: 1200, margin: '0 auto', fontSize: fontSize.xs, color: colors.textMuted }}>
          © {new Date().getFullYear()} DocMorphia. All rights reserved.
        </div>
      </footer>
    </div>
  )
}
